const VERIFICATION_EMAIL_COOLDOWN_KEY = "verification-email-cooldown-ts";
const VERIFICATION_EMAIL_COOLDOWN_MS = 60_000; // 60 seconds

export const isEmailVerificationCooldownActive = (): boolean => {
  const ts = localStorage.getItem(VERIFICATION_EMAIL_COOLDOWN_KEY);
  return !!ts && Date.now() - Number(ts) < VERIFICATION_EMAIL_COOLDOWN_MS;
};

export const startEmailVerificationCooldown = () => {
  localStorage.setItem(VERIFICATION_EMAIL_COOLDOWN_KEY, Date.now().toString());
};

export const getRemainingCooldownMs = (): number => {
  const ts = Number(
    localStorage.getItem(VERIFICATION_EMAIL_COOLDOWN_KEY) ?? "0",
  );
  return Math.max(0, VERIFICATION_EMAIL_COOLDOWN_MS - (Date.now() - ts));
};
